import { ExclusionListSelectorGzDataProvider } from '../dataProvider/ExclusionListSelectorGzDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_NIRVANA } from '../../../webcomponents.constants';

export class ExclusionListSelectorDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_NIRVANA, ExclusionListSelectorGzDataProvider);
  }
}
